export { default as getSelectedVariant } from './getSelectedVariant';
export { default as getUserIdentifier } from './getUserIdentifier';
export { default as isExperimentPlaying } from './isExperimentPlaying';
export { getPlayedExperiments } from '../reducers';
